import React, { useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import Page_ChatRoom_Room from "./Page_ChatRoom_Room";

import moment from "moment";
import axios from "axios";

import {
  Box,
  Paper,
  Grid,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import { pink } from "@mui/material/colors";

import classNames from "classnames";

import { FcGoogle as GoogleIcon } from "react-icons/fc";

// -------------------------------------------------  firebase - 1/3
import { authentication } from "../firebase-config";
import {
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

const {
  REACT_APP_ECLIPSE_API_PUBLIC,
  REACT_APP_ECLIPSE_API,
  REACT_APP_ECLIPSE_API_Local,
} = process.env;

// const socket = io.connect("http://localhost:8001");
const socket = io.connect("https://eclipserdp.dvrdns.org");

export default function Page_ChatRoom_Lobby() {
  // -------------------------------------------------  firebase - 2/3
  const [firebase_userInfo, setFirebase_userInfo] = useState({});

  onAuthStateChanged(authentication, (currentUser) => {
    setFirebase_userInfo(currentUser);
  });

  const singInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(authentication, provider)
      .then((re) => {
        setFirebase_userInfo(re);
        // console.log("re", re);
      })
      .catch((err) => {
        // console.log("re-err", err);
      });
  };

  const signInWithFacebook = () => {
    const provider = new FacebookAuthProvider();
    signInWithPopup(authentication, provider)
      .then((re) => {
        setFirebase_userInfo(re);
        // console.log("re", re);
      })
      .catch((err) => {
        // console.log("re-err", err);
      });
  };

  // -------------------------------------------------  firebase - 3/3

  useEffect(() => {
    // console.log("#useEffect 1", firebase_userInfo?.displayName);
    if (firebase_userInfo?.uid) {
      // console.log("a1", firebase_userInfo?.uid);
      // console.log("a1", firebase_userInfo?.email);
      getFirebaseAPI_DB_users_List(firebase_userInfo?.uid);

      username.current =
        firebase_userInfo?.providerData?.find(
          (x) => x.providerId == "facebook.com"
        ) != undefined
          ? firebase_userInfo?.providerData?.find(
              (x) => x.providerId == "facebook.com"
            ).displayName
          : "No Name";
      room.current = "NsZtx7tkRbpHzZDDPE3VzvLwZ9LkK1WMzOQCVGICnpl";
      // "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";
      joinRoom_Auto(username.current, room.current);

      // console.log(
      //   "x",
      //   firebase_userInfo?.providerData?.find(
      //     (x) => x.providerId == "facebook.com"
      //   ) != undefined
      //     ? firebase_userInfo?.providerData?.find(
      //         (x) => x.providerId == "facebook.com"
      //       ).displayName
      //     : "No Name"
      // );
    }
  }, [firebase_userInfo]);

  // ------------------------------------------------- DB

  // get user info by uid
  const [firebaseAPI_DB_users, setFirebaseAPI_DB_users] = useState([]);
  const getFirebaseAPI_DB_users_List = async (user_login_uid) => {
    const x = await axios
      .get(
        `${REACT_APP_ECLIPSE_API}/get_eclipse_event__event_user__byuid?user_login_uid=${user_login_uid}`
      )
      .then((res) => {
        setFirebaseAPI_DB_users(res.data[0]);
        // console.log("user_login_uid", user_login_uid);
        // console.log("getFirebaseAPI_DB_users_List", res.data[0]);
        if (res.data[0] != undefined) {
          // that is registered user
          setRegisteredUserStatus(true);
          // get the user data
          setDB_username(res.data[0].user_login_name);
          setSteamName(res.data[0].user_steamname);
          setRole(res.data[0].user_role);
          setUid(res.data[0].user_login_uid);
          setDB_uid(res.data[0].id);
        } else {
          setRegisteredUserStatus(false);
        }
      });
  };

  const [registeredUserStatus, setRegisteredUserStatus] = useState(false);
  const [steamName, setSteamName] = useState("NA");
  const [role, setRole] = useState("NA");
  const [uid, setUid] = useState("NA");
  const [DB_username, setDB_username] = useState("NA");
  const [DB_uid, setDB_uid] = useState("NA");

  const [totalOnlineUser, setTotalOnlineUser] = useState("0");
  // -------------------------------------------------  Chat room
  // const [username, setUsername] = useState("");
  // const [room, setRoom] = useState("");
  const username = useRef("");
  const room = useRef("");

  const [showChat, setShowChat] = useState(false);

  const joinRoom = () => {
    if (username.current !== "" && room.current !== "") {
      socket.emit("join_room", room.current);
      setShowChat(true);
    }
  };
  const joinRoom_Auto = (_username, _room) => {
    if (_username !== "" && _room !== "") {
      socket.emit("join_room", _room);
      setShowChat(true);
    }
  };

  useEffect(() => {
    socket.on("broadcast", (data) => {
      // console.log("#broadcast", data);
      setTotalOnlineUser(data);
    });
    socket.on("res_change_yt_rul", (data) => {
      // console.log("#res_change_yt_rul", data);
    });
  }, [socket]);

  return (
    <div
      style={{
        textAlign: "center",
        // padding: "0px 50px 0px 50px ",
      }}
    >
      {/* <Button
        style={{
          backgroundColor: "#ffffff",
          color: "#000000",
          width: "50%",
          textTransform: "none",
        }}
        onClick={() => {
          singInWithGoogle();
        }}
      >
        <GoogleIcon style={{ padding: "0px 10px 0px 0px", fontSize: "30px" }} />
        Login with Google
      </Button>
      <br />
      <br />
      <Button
        style={{
          backgroundColor: "#4064AC",
          color: "#ffffff",
          width: "50%",
          textTransform: "none",
        }}
        onClick={() => {
          signInWithFacebook();
        }}
      >
        <FacebookIcon
          style={{ padding: "0px 10px 0px 0px", fontSize: "30px" }}
        />{" "}
        Login with Facebook
      </Button> */}

      {/* {firebase_userInfo ? (
        <div
          style={{
            backgroundColor: "#4f4f4f",
            padding: "20px 0px 0px 20px",
            borderRadius: "10px",
          }}
        >
          <div style={{ color: "#ffffff" }}>
            <img
              src={
                firebase_userInfo?.providerData?.find(
                  (x) => x.providerId == "facebook.com"
                ) != undefined
                  ? firebase_userInfo?.providerData?.find(
                      (x) => x.providerId == "facebook.com"
                    ).photoURL
                  : `https://avatars.dicebear.com/api/pixel-art/${firebase_userInfo?.uid}.svg`
              }
              style={{ borderRadius: "50%", height: "60px" }}
            />

            <div>
              {firebase_userInfo?.providerData?.find(
                (x) => x.providerId == "facebook.com"
              ) != undefined
                ? firebase_userInfo?.providerData?.find(
                    (x) => x.providerId == "facebook.com"
                  ).displayName
                : "No Name"}
            </div>
            <div>{firebase_userInfo?.email}</div>

            <div style={{ color: "gray" }}>{firebase_userInfo?.uid}</div>
            <div style={{ color: "gold" }}>
              {registeredUserStatus ? "Registered User" : "Not yet Register"}
            </div>
            <div style={{ color: "gold" }}>{steamName}</div>
          </div>
          <Button
            style={{
              color: "#ff0000",
              width: "20%",
              textTransform: "none",
            }}
            onClick={() => {
              signOut(authentication);
            }}
          >
            LOGOUT
          </Button>
        </div>
      ) : (
        <div></div>
      )} */}

      {!showChat ? (
        // <div className="joinChatContainer">
        //   <h3>Join A Chat</h3>

        //   <input
        //     type="text"
        //     placeholder="your Name"
        //     onChange={(event) => {
        //       username.current = event.target.value;
        //     }}
        //   />
        //   <input
        //     type="text"
        //     placeholder="your Room ID"
        //     onChange={(event) => {
        //       room.current = event.target.value;
        //     }}
        //   />
        //   <button onClick={joinRoom}> Join A Room</button>
        // </div>
        <>ss</>
      ) : (
        <Page_ChatRoom_Room
          socket={socket}
          username={DB_username}
          photoURL={
            firebase_userInfo?.providerData?.find(
              (x) => x.providerId == "facebook.com"
            ) != undefined
              ? firebase_userInfo?.providerData?.find(
                  (x) => x.providerId == "facebook.com"
                ).photoURL
              : `https://avatars.dicebear.com/api/pixel-art/${firebase_userInfo?.uid}.svg`
          }
          room={room.current}
          role={role}
          steamName={steamName}
          uid={uid}
          DB_uid={DB_uid}
          totalOnlineUser={totalOnlineUser}
        />
      )}
    </div>
  );
}
